import { styled, ToggleButton } from "@mui/material";

export const StyledToggleButton = styled(ToggleButton)`
    border: solid 1px #eee;
    border-radius: 0.5rem;
    margin-bottom: 0.5rem;
    &.MuiToggleButtonGroup-middleButton {
        border-left: solid 1px #eee !important;
        border-top-left-radius: 0.5rem !important;
        border-top-right-radius: 0.5rem !important;
        border-bottom-left-radius: 0.5rem !important;
        border-bottom-right-radius: 0.5rem !important;
    }
    &.Mui-selected {
        background-color: ${({ theme }) => theme.palette.primary.main} !important;
        color: ${({ theme }) => theme.palette.primary.contrastText};
    }
    &.MuiToggleButtonGroup-firstButton,
    &.MuiToggleButtonGroup-lastButton {
        border-left: solid 1px #eee !important;
        border-top-left-radius: 0.5rem !important;
        border-top-right-radius: 0.5rem !important;
        border-bottom-left-radius: 0.5rem !important;
        border-bottom-right-radius: 0.5rem !important;
    }
    &.Mui-disabled {
        background-color: ${({ theme }) => theme.palette.action.disabledBackground} !important;
        color: ${({ theme }) => theme.palette.action.disabled} !important;
        cursor: not-allowed !important;
        pointer-events: none !important;
    }
`;
